import { useQuery } from "@tanstack/vue-query";
import { type MaybeRef } from "@vueuse/core";
import { api } from "@/api";

export const DISALLOW_CHECK_QUERY_KEY = "disallowCheck";

// Keep in sync with DisallowCheckOut
export type DisallowCheck = {
  registration: string;
  onDisallowList: boolean;
  note: string;
};

export const checkDisallowList = async (registration: string) => {
  const { body } = await api.get<DisallowCheck>("/disallow/check", {
    query: { registration },
  });
  return body;
};

/** Is this registration on the Disallow List? Checked as it is typed. */
export const useDisallowCheck = (registration: MaybeRef<string>) => {
  const normalised = computed(() =>
    unref(registration).replace(/\s/g, "").toUpperCase(),
  );
  const typed = refDebounced(normalised, 400);

  return useQuery({
    queryKey: [DISALLOW_CHECK_QUERY_KEY, typed],
    queryFn: ({ queryKey: [_prefix, reg] }) => checkDisallowList(unref(reg)),
    enabled: computed(() => typed.value.length >= 2),
    staleTime: 30_000,
  });
};
